@if (isModal()) {
  <button
    [attr.aria-label]="'button.close' | translate"
    class="close"
    (click)="dismissModal()"
  >
    <span
      aria-hidden="true"
      inlineSVG="/assets/icons/close.svg"
    ></span>
  </button>
}

<app-card [className]="'card--summary'">
  <div class="card--summary__inner about">
    <div class="card--summary__head">
      <div>
        <h2>{{ 'project.home.about.title' | translate }}</h2>
      </div>
    </div>
    <div class="card__content">
      <div
        class="card--summary__description"
        [appTranslateText]="project().description"
        [html]="project().description"
        [language]="project().language"
      ></div>
      @if (project().customer.logoThumbnails) {
        <div class="card--summary__image">
          <img
            [src]="project().customer.logoThumbnails.medium"
            [alt]="project().name + ' logo'"
          />
        </div>
      }
    </div>
  </div>
</app-card>

@for (category of documentCategories; let i = $index; track category) {
  <app-card [className]="'card--summary'">
    <div class="card--summary__inner documents">
      <div class="card--summary__head">
        <div>
          <h2 [attr.lang]="contentLanguage()">
            {{ category.title }}
          </h2>
        </div>
      </div>
      <div class="card__content">
        <div
          class="card--summary__description"
          [appTranslateText]="category.content"
          [html]="category.content"
          [language]="project().language"
        ></div>
      </div>
      <ul class="card--summary__documents">
        @for (document of category.documents; let j = $index; track document) {
          <li class="document ion-activatable">
            <button
              class="open-modal"
              (click)="openModal(i, j)"
            >
              <div class="document__image">
                @if (isImage(document) || isPdf(document)) {
                  <img
                    [src]="document.filePathThumbnails?.small"
                    alt=""
                  />
                }
                @if (isVideo(document)) {
                  <img
                    [src]="document.thumbnailPathThumbnails?.small"
                    alt=""
                  />
                }
                @if (isYoutube(document)) {
                  <img
                    alt=""
                    src="/assets/icons/youtube.svg"
                  />
                }
              </div>
              <div class="document__content">
                <span [attr.lang]="contentLanguage()">
                  {{ document.title }}
                </span>
              </div>
            </button>
            <ion-button
              [attr.aria-label]="'project.home.about.file.download' | translate"
              class="document__download"
              color="dark"
              fill="clear"
              (click)="downloadDocument(document)"
            >
              <ion-icon
                slot="icon-only"
                aria-hidden="true"
                src="/assets/icons/download.svg"
              ></ion-icon>
            </ion-button>
          </li>
        }
      </ul>
    </div>
  </app-card>
}

<app-card
  [className]="'card--summary card--about-us'"
  #mapContainer
>
  <div class="card--summary__inner map">
    <div class="card--summary__head">
      <div>
        <h2>{{ 'project.home.about.map.title' | translate }}</h2>
      </div>
    </div>
    <div class="card--summary__map">
      @if (mapShouldLoad) {
        <app-map
          (mapLoaded)="mapLoaded($event)"
          [zoom]="17"
          [center]="[project().locationLong, project().locationLat]"
        ></app-map>
      }
    </div>
  </div>
</app-card>

<app-card
  [className]="'card--summary'"
  [type]="CardType.ORGANISATION"
  [project]="project()"
></app-card>
